<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="850"
    >
      <v-btn
        slot="activator"
        color="red lighten-2"
        dark
      >
        Click Me
      </v-btn>

      <v-card>
        <v-layout xs12 >
          <v-flex>
            <v-card class="date-picker-card">
              <v-card-title >
                <v-layout xs12>
                  <v-flex>
                    <h1 class="text-xs-center" >Select Time</h1>
                  </v-flex>
                </v-layout>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout xs12>
          <v-flex xs12 class="">
            <DraggableCal :accentColor="red" :years=5 @selectedDate="doSomething($event)"></DraggableCal>
            <!--<v-date-picker class="date-picker" v-model="picker" landscape ></v-date-picker>-->
          </v-flex>
        </v-layout>
        <v-layout xs12>
          <v-flex xs12 class="px-3">
            <v-list >
              <v-card  class="datapicker-card">
                <v-list-tile @click="">
                  <v-list-tile-content>
                    <v-list-tile-title>08.00</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon>fas fa-chevron-right</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </v-card>
              <v-divider color="#999" ></v-divider>
              <v-card  class="datapicker-card">
                <v-list-tile @click="">
                  <v-list-tile-content>
                    <v-list-tile-title>09.00</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon>fas fa-chevron-right</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </v-card>
              <v-divider color="#999" ></v-divider>
              <v-card  class="datapicker-card">
                <v-list-tile @click="">
                  <v-list-tile-content>
                    <v-list-tile-title>10.00</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon>fas fa-chevron-right</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </v-card>
              <v-divider color="#999" ></v-divider>
              <v-card  class="datapicker-card">
                <v-list-tile @click="">
                  <v-list-tile-content>
                    <v-list-tile-title>11.00</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon>fas fa-chevron-right</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </v-card>
              <v-divider color="#999" ></v-divider>
              <v-card  class="datapicker-card">
                <v-list-tile @click="">
                  <v-list-tile-content>
                    <v-list-tile-title>12.00</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon>fas fa-chevron-right</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </v-card>
              <v-divider color="#999" ></v-divider>
            </v-list>
          </v-flex>
        </v-layout>
        <v-layout xs12>
          <v-flex xs12 class="text-xs-center">
            <v-btn class="btn" color="#0051a0">add</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  /* eslint-disable */
  import DraggableCal from 'vue-draggable-cal';
  export default {
    data () {
      return {
        picker: new Date().toISOString().substr(0, 10)
      }
    },
    components: {
      DraggableCal,
    },
  }
</script>
<style>
  .drag-calendar .days .cell[data-v-5af1977c] {
    float: right;
    width: 2rem;
    padding: 1.05rem 1.05rem;
    margin: 0;
    border-right: 1px solid rgba(0, 0, 0, .03);
    /* text-align: center; */
    /* position: relative; */
    color: #888;
  }
  .drag-calendar[data-v-5af1977c]{
    height: auto;
    width: 100%;
    overflow-x: scroll !important;
  }


  /*.date-picker-card h1{*/
    /*color:#0051a0;*/
  /*}*/

  /*.date-picker{*/
    /*width:100% !important;*/
  /*}*/
  /*.datapicker-card{*/
    /*box-shadow: None !important;*/
  /*}*/
  /*.btn{*/
    /*width: 50%;*/
    /*color: #fff !important;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/pages/pages/classes/SelectTime.vue